import createMutation from '../utils/createMutation';

export const getActiveReportTypeList = createMutation(
  '/MedicalService/GetActiveReportTypeList',
);
